import React, { useState } from 'react';
import classnames from 'classnames';
import { InputCheckbox } from '../Inputs';
import TableRow from './TableRow/TableRow';
import {
  CommercialTitleFeesOwnersPremiumBody,
  ResidentialTitleFeesOwnersPremiumBody,
} from './TableBody';

const TitleFeesOwnersPremiumTable = ({
  ownersTitleResults,
  calculatorType,
  className,
  checkboxConstants,
  setCheckedOwners,
  title,
  subtitle,
  totals,
}) => {
  let tbody;
  const [values, setValues] = useState(checkboxConstants);

  // function to handle the on change event on table checkboxes, to set their
  // state in order to use it on the parent calculator container component
  function handleInputChange(event) {
    const target = event.target;
    setValues({ ...values, [target.name]: target.checked });
    setCheckedOwners({ ...values, [target.name]: target.checked });
  }

  // Dynamically render table body based on what calculatorType is selected
  const calculatorTypes = {
    commercialTitleFees: CommercialTitleFeesOwnersPremiumBody,
    residentialTitleFees: ResidentialTitleFeesOwnersPremiumBody,
  };
  const TitleFeesOwnersPremiumTableBody = calculatorTypes[calculatorType];

  return (
    <div className="calc__box">
      <h1 className="calc__title">{title}</h1>
      <h2 className="calc__title--sub">{subtitle}</h2>
      <table className={classnames('table', className)}>
        <TitleFeesOwnersPremiumTableBody
          {...ownersTitleResults}
          checkboxValues={values}
          totals={totals}
          handleInputChange={handleInputChange}
        />
      </table>
    </div>
  );
};

export default TitleFeesOwnersPremiumTable;
